var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","bottom":"","fixed":"","padless":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" Powered by — "),_c('strong',{staticClass:"purple--text darken-1"},[_vm._v("Humanious")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }